import axios from 'axios';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const Header = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
};

const APIs = (window.location.hostname === "localhost") ? "/" : "https://www.klscoop.or.th/APIs/";
const Domain = (window.location.hostname === "localhost") ? "http://localhost:3000" : "https://www.klscoop.or.th";

export function variable() {
    const variable = {
        BASE_URL: Domain,
        FacebookID: "869382536570928",
        platform : "website"
    };
    return variable;
}

export function _getToken() {
    return (localStorage.getItem('token') === '' || localStorage.getItem('token') === null) ? '' : localStorage.getItem('token');
}

export async function _getdata(url) {
    return await axios({url:url, method: 'get', timeout: 10000, headers: Header});
}

export async function _get(url) {
    return await axios({url: APIs + url, method: 'get', timeout: 10000, headers: Header});
}

export async function _post(url, param) {
    return await axios({url: APIs + url, method: 'post', timeout: 10000, headers: Header, data: param});
}

export function _Alert(t, type = '', title = '', content = '') {
    title = (title === '') ? 'แจ้งเตือน' : '';
    const MySwal = withReactContent(Swal);
    if ( t === 'error' ) {
        MySwal.fire({ type: 'error', title: 'แจ้งเตือน', text: 'พบข้อผิดพลาดบางอย่าง กรุณาลองใหม่อีกครั้ง' });
    } else if ( t === 'modify' ) {
        MySwal.fire({ type: type, title: title, text: content });
    } else if ( t === 'token_fail' ) {
        MySwal.fire({ type: 'error', title: title, text: content }).then((result) => { if ( result.value ) window.location.href = Domain + "/online"; });
    } else {
        MySwal.fire({ text: t })
    }
}

export function _infoAlert(){
    const  MySwal = withReactContent(Swal);
    MySwal.fire({
        title: 'ประกาศ',
        text : "ระบบกำลังอยู่ในช่วงการทดลองใช้งาน หากพบปัญหากรุณาแจ้งสหกรณ์ฯ\n" +
            "โทรศัพท์ : 043-873666 , 043-873667  และ 086-4587697\n" +
            "Line ID: klscoop"
    });
}

export function _formatDateToText(date, language = 'TH', short = true, time = true) {
    let month_name = '';
    if ( short ) {
      month_name = [ 
        {"EN":"January","TH":"มกราคม"},{"EN":"February","TH":"กุมภาพันธ์"},{"EN":"March","TH":"มีนาคม"},{"EN":"April","TH":"เมษายน"},{"EN":"May","TH":"พฤษภาคม"},{"EN":"June","TH":"มิถุนายน"},
        {"EN":"July","TH":"กรกฎาคม"},{"EN":"August","TH":"สิงหาคม"},{"EN":"September","TH":"กันยายน"},{"EN":"October","TH":"ตุลาคม"},{"EN":"November","TH":"พฤศจิกายน"},{"EN":"December","TH":"ธันวาคม"} 
      ]
    } else {
      month_name = [ 
        {"EN":"Jan","TH":"ม.ค."},{"EN":"Feb","TH":"ก.พ."},{"EN":"Mar","TH":"มี.ค."},{"EN":"Apr","TH":"เม.ย."},{"EN":"May","TH":"พ.ค."},{"EN":"Jun","TH":"มิ.ย."},
        {"EN":"Jul","TH":"ก.ค."},{"EN":"Aug","TH":"ส.ค."},{"EN":"Sep","TH":"ก.ย."},{"EN":"Oct","TH":"ต.ค."},{"EN":"Nov","TH":"พ.ย."},{"EN":"Dec","TH":"ธ.ค."} 
      ]
    }
    let day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let month = ( language.toUpperCase() === "EN" ) ? month_name[monthIndex].EN : month_name[monthIndex].TH
    let cYear = ( language.toUpperCase() === "EN" ) ? year : (+year + 543).toString()
    let times = (date.getHours() < 10 ? '0' : '') + date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes() + ':' + (date.getSeconds() < 10 ? '0' : '') + date.getSeconds()
    let cTimes = ( language.toUpperCase() === "EN" ) ? this.formatAMPM(times) : times
    let ConvertDate = ( time ) ? day + ' ' + month + ' ' + cYear + '  ' + cTimes : day + ' ' + month + ' ' + cYear
    return ConvertDate
}

export function _setTime() {
    if (localStorage.getItem("token") !== null) {
      var d = new Date();
      var v = new Date();
      v.setMinutes(d.getMinutes() + 5);
      localStorage.setItem("timeOut", v.toString());
    }
}

export function _timeOut() {
    let timer = setInterval(()=>{
      let time = new Date(localStorage.getItem("timeOut"))
      if( time < new Date() ) {
        console.log('Session Time Out: LogOut')
        clearInterval(timer)
        //localStorage.clear();
        localStorage.removeItem('token');
        localStorage.removeItem('timeOut');
        window.location.href = Domain + "/online";
      }
    }, 1000)
}

export function _logOut() {
    //localStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('timeOut');
    window.location.href = Domain + "/online";
}

export function _toMessage() {
    window.location.href = Domain + "/online/message";
}

export function _isLoginPage() {
    if ( localStorage.getItem("timeOut") !== null || localStorage.getItem("token") !== null ) {
        let time = new Date(localStorage.getItem("timeOut"))
        if( time < new Date() ) {
            setTimeout(()=>{
                window.location.href = Domain + "/online/dashboard";
            }, 1000)
        }
    }
}

export async function _isLogin() {
    if ( localStorage.getItem("timeOut") === null || localStorage.getItem("token") === null ) {
        //localStorage.clear();
        localStorage.removeItem('token');
        localStorage.removeItem('timeOut');
        window.location.href = Domain + "/online";     
    } else {
        let time = new Date(localStorage.getItem("timeOut"))
        if( time < new Date() ) {
            //localStorage.clear();
            localStorage.removeItem('token');
            localStorage.removeItem('timeOut');
            window.location.href = Domain + "/online";
        } else {
            return true;
        }
    }
}

